/* eslint-disable import/extensions */

// Clients Img Imports
import servicestream from '../assets/images/Services/servicestream.png';
import telstra from '../assets/images/Services/telstra.png';
import ventia from '../assets/images/Services/ventia.png';
import downer from '../assets/images/Services/downer.png';
import fulton from '../assets/images/Services/fulton.png';

// Services Img Imports
import hydro from '../assets/images/Portfolio/hydro.png';
import tele from '../assets/images/Portfolio/tele.png';
import acm from '../assets/images/Portfolio/acm.png';
import field from '../assets/images/Portfolio/field.png';
import civil from '../assets/images/Portfolio/civil.png';
import laying from '../assets/images/Portfolio/laying.png';
// import asbestos from '../assets/images/Portfolio/asbestos.png';

// Advantages
import Communicative from '../assets/images/Advantages/Communicative.png';
import Collaborative from '../assets/images/Advantages/Collaborative.png';
import Management from '../assets/images/Advantages/Management.png';
import Favorite from '../assets/images/Advantages/Favorite.png';

export const Clients = [
  {
    title: 'ServiceStream',
    imageUrl: servicestream,
    animation: 'left',
  },
  {
    title: 'Ventia',
    imageUrl: ventia,
    animation: 'up',
  },
  {
    title: 'Downer',
    imageUrl: downer,
    animation: 'up',
  },
  {
    title: 'Telstra',
    imageUrl: telstra,
    animation: 'up',
  },
  {
    title: 'Fulton Hogan',
    imageUrl: fulton,
    animation: 'right',
  },
];

export const Services = [
  {
    id: 'HydroExcavation',
    title: 'Hydro Excavation',
    imageUrl: hydro,
    description: `Hydro excavation is one of the advanced, non-destructive digging services offered by our team, combining high-pressure water and vacuum technology to safely expose underground utilities.

It's the ideal solution for projects where accuracy matters — especially in areas with unmarked services or high-risk zones — ensuring minimal disruption, maximum safety, and complete confidence in the worksite.`,
  },
  {
    id: 'TeleCommunications',
    title: 'Telecommunications',
    imageUrl: tele,
    description: `MS Contractors is a trusted provider of comprehensive telecommunication services, including NBN installations, pit and pipe works, and conduit management.

We specialise in projects that involve civil works, such as trenching, concrete cutting and removal, and bitumen restoration—essential for completing underground telecommunications infrastructure.

Our skilled team is fully equipped and experienced in handling complex NBN installations and fault rectifications. Whether the job requires creating trenches beneath footpaths or driveways, installing or repairing telecommunication pits, or managing conduit systems, we deliver safe, efficient, and compliant solutions.`,
  },
  {
    id: 'ACMRemoval',
    title: 'ACM Removal',
    imageUrl: acm,
    description: `MS Contractors is a licensed and experienced provider of ACM (Asbestos-Containing Material) removal services, with a strong focus on safety, compliance, and environmental responsibility.

We specialise in the safe identification, management, and removal of bonded asbestos materials commonly found in telecommunications infrastructure, including pits, pipes, and conduits. Our team follows strict industry regulations and Work Health & Safety (WHS) standards to ensure every job is completed with minimal risk to people and the environment.

Whether it's part of a civil works project or a standalone asbestos removal task, our qualified staff use approved methods and equipment to contain, remove, and dispose of ACMs responsibly. We also provide clear documentation and clearance certificates as part of our commitment to transparency and regulatory compliance.`,
  },
  {
    id: 'FieldServiceActivities',
    title: 'Field Service Activities',
    imageUrl: field,
    description: `MS Contractors has a highly skilled and reliable field services team, experienced in delivering projects of all sizes across Australia’s telecommunications infrastructure. From building next-generation broadband networks to upgrading and maintaining legacy copper and hybrid systems, our field technicians are equipped to carry out a wide range of essential services with precision and efficiency.

Our field services include:
• Fibre-optic cable installation, splicing, termination, activation, and commissioning
• Copper cable installation, termination, activation, and commissioning
• HFC (Hybrid Fibre-Coaxial) installation, termination, activation, and commissioning
• Aerial cabling and overhead installations
• Network and end-to-end fault diagnosis and repair
• Asset relocations and infrastructure adjustments
• Civil and support works associated with telecommunications builds
• Railway track-related telecommunications works

With a strong focus on safety, compliance, and timely delivery, our field teams support Australia’s major network providers in building and maintaining critical connectivity infrastructure.`,
  },
  {
    id: 'CivilConstruction',
    title: 'Civil Construction',
    imageUrl: civil,
    description: `MS Contractors provides specialised civil construction and telecommunications services across Australia’s rail, mining, and resources sectors, as well as for government and private organisations nationwide.
With a strong track record of delivering projects on time and within budget — even in the most remote locations — our clients rely on us for certainty, quality, and expertise at every stage of the project lifecycle.

Our end-to-end capabilities are delivered through a highly experienced network of field subcontractors and supported by dedicated in-house teams. We offer expert services in:

• Engineering and design
• Project management
• Civil construction and infrastructure works
• Telecommunications installation
• System commissioning

We ensure each project is executed with a strong focus on safety, compliance, and performance to meet the technical and operational needs of our clients.`,
  },
  {
    id: 'Asphalt&Concretelaying',
    title: 'Asphalt & Concrete laying',
    imageUrl: laying,
    description: `MS Contractors delivers high-quality asphalt and concrete laying services as part of our broader civil and telecommunications infrastructure capabilities.
Our team is experienced in working across a wide range of environments — from urban streetscapes to remote industrial sites — ensuring a durable, safe, and clean finish that meets all project and regulatory requirements.

We specialise in:

• Footpath and driveway reinstatement
• Road and pavement repairs
• Pit and trench resurfacing
• Slab pouring for equipment and enclosures
• Concrete cutting and removal
• Bitumen patching and full resurfacing

Whether supporting telecommunications builds, utility upgrades, or civil infrastructure works, we ensure all surface restoration is completed efficiently, with minimal disruption to the surrounding environment.`,
  },
];

export const Advantages = [
  [{
    title: 'Communicative',
    description: 'We keep our team and stakeholders informed by clearly communicating the project ideas and progress.',
    imageUrl: Communicative,
  },
  {
    title: 'Management',
    description: 'We manage our projects with care and efficiency to achieve the best possible outcomes.',
    imageUrl: Management,
  }],
  [{
    title: 'Collaborative​',
    description: 'Our team works very collaboratively to ensure the success of our project.',
    imageUrl: Collaborative,
  },
  {
    title: 'Favorite',
    description: "We have successfully completed numerous projects, and our clients have been very satisfied with the results.",
    imageUrl: Favorite,
  }],
];
